/* esm.sh - applesauce-common@5.2.0/dist/helpers/zap-goal */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/zap-goal.mjs";
